__turbopack_context__.v({
  "avatar": "CVDocument-module__zMDc6q__avatar",
  "contentGrid": "CVDocument-module__zMDc6q__contentGrid",
  "contentGridBody": "CVDocument-module__zMDc6q__contentGridBody",
  "contentGridTitle": "CVDocument-module__zMDc6q__contentGridTitle",
  "detailList": "CVDocument-module__zMDc6q__detailList",
  "employment": "CVDocument-module__zMDc6q__employment",
  "employments": "CVDocument-module__zMDc6q__employments",
  "list": "CVDocument-module__zMDc6q__list",
  "portfolio": "CVDocument-module__zMDc6q__portfolio",
  "portfolioBody": "CVDocument-module__zMDc6q__portfolioBody",
  "portfolioFigure": "CVDocument-module__zMDc6q__portfolioFigure",
  "portfolioImage": "CVDocument-module__zMDc6q__portfolioImage",
  "roleLogo": "CVDocument-module__zMDc6q__roleLogo",
  "roleTitle": "CVDocument-module__zMDc6q__roleTitle",
  "roleTitleCompany": "CVDocument-module__zMDc6q__roleTitleCompany",
  "roleTitlePos": "CVDocument-module__zMDc6q__roleTitlePos",
  "root": "CVDocument-module__zMDc6q__root",
  "top": "CVDocument-module__zMDc6q__top",
});
